module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/desktop/2@2.gif?d30c7bf254ca5fd4298ecf075d5d0cc8";